import moment from 'moment';

function getFirstFixStyleElement(doc: any, color: any) {
  const styleElem = getFirstOrLastFixStyleElement(doc, 'FirstFix', color);

  return styleElem;
}

function getLastFixStyleElement(doc: any, color: any) {
  const styleElem = getFirstOrLastFixStyleElement(doc, 'LastFix', color);

  return styleElem;
}

function getFirstOrLastFixStyleElement(doc: any, id: any, color: any) {
  // eslint-disable-next-line sonarjs/no-clear-text-protocols
  const squareIconURL = 'http://maps.google.com/mapfiles/kml/shapes/square.png';

  const styleElem = createStyleElement(doc, id, squareIconURL, color, '1');

  const balloonStyleElement = doc.createElement('BalloonStyle');
  const displayModeElement = doc.createElement('displayMode');
  displayModeElement.innerHTML = 'hide';
  balloonStyleElement.appendChild(displayModeElement);

  styleElem.appendChild(balloonStyleElement);

  return styleElem;
}

function getFixDotStyle(doc: any, color: any) {
  // eslint-disable-next-line sonarjs/no-clear-text-protocols
  const circleIconURL = 'http://maps.google.com/mapfiles/kml/shapes/placemark_circle.png';

  const styleElem = createStyleElement(doc, 'FixDot', circleIconURL, color, '0.7');

  const balloonStyleElement = doc.createElement('BalloonStyle');
  const textColorElement = doc.createElement('textColor');
  textColorElement.innerHTML = 'FF000000';
  const bgColorElement = doc.createElement('bgColor');
  bgColorElement.innerHTML = 'FFFFF0FF';
  const textElement = doc.createElement('text');
  textElement.innerHTML =
    '<![CDATA[<font size=+1><b><u>Record Info</u></b><br></font>]]>$[description]';

  balloonStyleElement.appendChild(textColorElement);
  balloonStyleElement.appendChild(bgColorElement);
  balloonStyleElement.appendChild(textElement);

  styleElem.appendChild(balloonStyleElement);

  return styleElem;
}

function getTrackStyleElement(doc: any, color: any) {
  const styleElem = doc.createElement('Style');
  styleElem.setAttribute('id', 'TrackStyle');
  const lineStyleElem = doc.createElement('LineStyle');
  const lineColorStyleElem = doc.createElement('color');
  lineColorStyleElem.innerHTML = color;
  const polyColorStyleElem = doc.createElement('color');
  polyColorStyleElem.innerHTML = '3f00ff00';
  const polyStyleElem = doc.createElement('PolyStyle');

  lineStyleElem.appendChild(lineColorStyleElem);
  polyStyleElem.appendChild(polyColorStyleElem);
  styleElem.appendChild(lineStyleElem);
  styleElem.appendChild(polyStyleElem);

  return styleElem;
}

function getPlaceMarkPositionElement(
  doc: any,
  position: any,
  index: any,
  length: any,
  collarName: any,
) {
  const placeMarkElement = createPlacemarkDot(doc, 'Fix #' + (index + 1), '#FixDot', position);

  const timeStampElement = doc.createElement('TimeStamp');
  const whenElement = doc.createElement('when');
  whenElement.innerHTML = moment.utc(position.acquisitionTime).toISOString();
  timeStampElement.appendChild(whenElement);

  const descriptionElement = doc.createElement('description');
  descriptionElement.innerHTML =
    `
    <![CDATA[<table style="width: 200px;">
        <th style="font-weight: bold;font-style: italic; align:center;" colspan="2">Collar ` +
    collarName +
    ` - Fix #1</th>
        <tr>
            <td style="width:85px">Date:</td>
            <td style="width:115px">` +
    moment.utc(position.acquisitionTime).format('DD-MM-YYYY') +
    `</td>
        </tr>
        <tr>
            <td>Time:</td>
            <td>` +
    moment.utc(position.acquisitionTime).format('HH:mm:ss') +
    `</td>
        </tr>
        <tr>
            <td>Altitude:</td>
            <td>` +
    position.altitude +
    `</td>
        </tr>
        <tr>
            <td>Status:</td>
            <td>` +
    position.fixType +
    `</td>
        </tr>
        <tr>
            <td>DOP:</td>
            <td>` +
    position.dop +
    `</td>
        </tr>
        <tr>
            <td>Sats used:</td>
            <td>` +
    position.satCount +
    `</td>
        </tr>
        <tr>
            <td>Temperature:</td>
            <td>` +
    position.temperature +
    `</td>
        </tr>
    </table>]]>
    `;

  placeMarkElement.appendChild(timeStampElement);
  placeMarkElement.appendChild(descriptionElement);

  return placeMarkElement;
}

function getPointElement(doc: any, latitude: any, longitude: any, height: any) {
  const pointElement = doc.createElement('Point');
  const altitudeModeElement = doc.createElement('altitudeMode');
  altitudeModeElement.innerHTML = 'clampToGround';
  const coordinatesElement = doc.createElement('coordinates');
  if (latitude && longitude) {
    coordinatesElement.innerHTML = longitude.toFixed(7) + ',' + latitude.toFixed(7) + ',' + height;
  } else {
    coordinatesElement.innerHTML = longitude + ',' + latitude + ',' + height;
  }

  pointElement.appendChild(altitudeModeElement);
  pointElement.appendChild(coordinatesElement);

  return pointElement;
}

function getTrackElement(
  doc: any,
  position: any,
  previousPos: any,
  index: any,
  length: any,
  trackColor: any,
) {
  if (!previousPos) {
    return;
  }

  const placeMarkElement = doc.createElement('Placemark');
  const placeMarkNameElement = doc.createElement('name');
  placeMarkNameElement.innerHTML = 'Fix ' + index + ' to Fix ' + (index + 1);
  const styleUrlElement = doc.createElement('styleUrl');
  styleUrlElement.innerHTML = '#TrackStyle';
  const timeStampElement = doc.createElement('TimeStamp');
  const whenElement = doc.createElement('when');
  whenElement.innerHTML = moment.utc(position.acquisitionTime).toISOString();
  timeStampElement.appendChild(whenElement);
  const lineStringElement = doc.createElement('LineString');
  const coordinatesElement = doc.createElement('coordinates');
  if (position.latitude && position.longitude && previousPos.longitude && previousPos.latitude) {
    coordinatesElement.innerHTML =
      position.longitude.toFixed(7) +
      ',' +
      position.latitude.toFixed(7) +
      ',' +
      position.height +
      ' ' +
      previousPos.longitude.toFixed(7) +
      ',' +
      previousPos.latitude.toFixed(7) +
      ',' +
      previousPos.height;
  } else {
    coordinatesElement.innerHTML =
      position.longitude +
      ',' +
      position.latitude +
      ',' +
      position.height +
      ' ' +
      previousPos.longitude +
      ',' +
      previousPos.latitude +
      ',' +
      previousPos.height;
  }

  const altitudeModeElement = doc.createElement('altitudeMode');
  altitudeModeElement.innerHTML = 'clampToGround';
  const extrudeElement = doc.createElement('extrude');
  extrudeElement.innerHTML = '0';

  lineStringElement.appendChild(coordinatesElement);
  lineStringElement.appendChild(altitudeModeElement);
  lineStringElement.appendChild(extrudeElement);

  const styleElement = doc.createElement('Style');
  const lineStyleElement = doc.createElement('LineStyle');
  const colorElement = doc.createElement('color');
  colorElement.innerHTML = trackColor;
  const widthElement = doc.createElement('width');
  widthElement.innerHTML = '3';

  lineStyleElement.appendChild(colorElement);
  lineStyleElement.appendChild(widthElement);
  styleElement.appendChild(lineStyleElement);

  placeMarkElement.appendChild(placeMarkNameElement);
  placeMarkElement.appendChild(styleUrlElement);
  placeMarkElement.appendChild(timeStampElement);
  placeMarkElement.appendChild(lineStringElement);
  placeMarkElement.appendChild(styleElement);

  return placeMarkElement;
}

function getLookAtElement(doc: any, previousPos: any) {
  const lookAtElement = doc.createElement('LookAt');
  const longitudeElement = doc.createElement('longitude');
  longitudeElement.innerHTML = previousPos.longitude;
  const latitudeElement = doc.createElement('latitude');
  latitudeElement.innerHTML = previousPos.latitude;
  const rangeElement = doc.createElement('range');
  rangeElement.innerHTML = '10000.0';
  const tiltElement = doc.createElement('tilt');
  tiltElement.innerHTML = '0';
  const headingElement = doc.createElement('heading');
  headingElement.innerHTML = '0';

  lookAtElement.appendChild(longitudeElement);
  lookAtElement.appendChild(latitudeElement);
  lookAtElement.appendChild(rangeElement);
  lookAtElement.appendChild(tiltElement);
  lookAtElement.appendChild(headingElement);

  return lookAtElement;
}

function createFolderElement(doc: any, name: any) {
  const folderElement = doc.createElement('Folder');
  const nameElement = doc.createElement('name');
  nameElement.innerHTML = name;
  const visibilityElement = doc.createElement('visibility');
  visibilityElement.innerHTML = '1';

  folderElement.appendChild(nameElement);
  folderElement.appendChild(visibilityElement);

  return folderElement;
}

function createPlacemarkDot(doc: any, name: any, styleUrl: any, position: any) {
  const placeMarkElement = doc.createElement('Placemark');
  const nameElement = doc.createElement('name');
  nameElement.innerHTML = name;
  const visibilityElement = doc.createElement('visibility');
  visibilityElement.innerHTML = '1';
  const styleUrlElement = doc.createElement('styleUrl');
  styleUrlElement.innerHTML = styleUrl;
  const pointElement = getPointElement(doc, position.latitude, position.longitude, position.height);

  placeMarkElement.appendChild(nameElement);
  placeMarkElement.appendChild(visibilityElement);
  placeMarkElement.appendChild(styleUrlElement);
  placeMarkElement.appendChild(pointElement);

  return placeMarkElement;
}

function createStyleElement(doc: any, id: any, iconURL: any, color: any, scale: any) {
  const styleElem = doc.createElement('Style');
  styleElem.setAttribute('id', id);

  const iconStyleElement = doc.createElement('IconStyle');
  const iconElement = doc.createElement('Icon');
  const hrefElement = doc.createElement('href');
  hrefElement.innerHTML = iconURL;

  const colorElement = doc.createElement('color');
  colorElement.innerHTML = color;

  const scaleElement = doc.createElement('scale');
  scaleElement.innerHTML = scale;

  const hotSpotElement = doc.createElement('hotSpot');
  hotSpotElement.setAttribute('x', '0.5');
  hotSpotElement.setAttribute('xunits', 'fraction');
  hotSpotElement.setAttribute('y', '0.5');
  hotSpotElement.setAttribute('yunits', 'fraction');

  const labelStyleElement = doc.createElement('LabelStyle');
  const labelColorElement = doc.createElement('color');
  labelColorElement.innerHTML = '00000000';
  labelStyleElement.appendChild(labelColorElement);

  iconElement.appendChild(hrefElement);
  iconStyleElement.appendChild(iconElement);
  iconStyleElement.appendChild(colorElement);
  iconStyleElement.appendChild(scaleElement);
  iconStyleElement.appendChild(hotSpotElement);
  styleElem.appendChild(iconStyleElement);
  styleElem.appendChild(labelStyleElement);
  return styleElem;
}

export const createKMLFile = function (
  positions: any,
  collarName: any,
  oldestPositionMarkerColor?: any,
  newestPositionMarkerColor?: any,
) {
  if (!positions.length) {
    return '';
  }

  if (oldestPositionMarkerColor) {
    oldestPositionMarkerColor = convertHexToABGR(oldestPositionMarkerColor);
  } else {
    oldestPositionMarkerColor = 'FF00FF00';
  }

  if (newestPositionMarkerColor) {
    newestPositionMarkerColor = convertHexToABGR(newestPositionMarkerColor);
  } else {
    newestPositionMarkerColor = 'FF0000FF';
  }

  const iconColor = 'FFFF0000';
  const trackColor = 'FF00FFFF';

  const doc = document.implementation.createDocument('', '', null);

  const kmlElement = doc.createElement('kml');
  // eslint-disable-next-line sonarjs/no-clear-text-protocols
  kmlElement.setAttribute('xmlns', 'http://earth.google.com/kml/2.2');

  const documentElement = doc.createElement('Document');

  const nameElement = doc.createElement('name');
  nameElement.innerHTML = 'Collar ' + collarName;

  const descriptionElement = doc.createElement('description');
  descriptionElement.innerHTML = 'GPS Plus X - www.vectronic-aerospace.com';

  const firstFixStyleElement = getFirstFixStyleElement(doc, oldestPositionMarkerColor);
  const lastFixStyleElement = getLastFixStyleElement(doc, newestPositionMarkerColor);
  const fixDotStyleElement = getFixDotStyle(doc, iconColor);
  const trackStyleElement = getTrackStyleElement(doc, trackColor);

  const firstPlaceMarkElement = createPlacemarkDot(
    doc,
    'First Position Mark',
    '#FirstFix',
    positions[0],
  );
  const lastPlaceMarkElement = createPlacemarkDot(
    doc,
    'Last Position Mark',
    '#LastFix',
    positions[positions.length - 1],
  );

  const fixesFolderElement = createFolderElement(doc, 'Fixes');
  const tracksFolderElement = createFolderElement(doc, 'Tracks');
  tracksFolderElement.setAttribute('id', 'Tracks');

  let previousPos = null;
  for (let i = 0; i < positions.length; i++) {
    const placeMarkElement = getPlaceMarkPositionElement(
      doc,
      positions[i],
      i,
      positions.length,
      collarName,
    );
    fixesFolderElement.appendChild(placeMarkElement);

    const trackElement = getTrackElement(
      doc,
      positions[i],
      previousPos,
      i,
      positions.length,
      trackColor,
    );
    if (trackElement) {
      tracksFolderElement.appendChild(trackElement);
    }

    previousPos = positions[i];
  }

  const lookAtElement = getLookAtElement(doc, previousPos);

  documentElement.appendChild(nameElement);
  documentElement.appendChild(descriptionElement);
  documentElement.appendChild(firstFixStyleElement);
  documentElement.appendChild(lastFixStyleElement);
  documentElement.appendChild(fixDotStyleElement);
  documentElement.appendChild(trackStyleElement);
  documentElement.appendChild(firstPlaceMarkElement);
  documentElement.appendChild(lastPlaceMarkElement);
  documentElement.appendChild(fixesFolderElement);
  documentElement.appendChild(tracksFolderElement);
  documentElement.appendChild(lookAtElement);
  kmlElement.appendChild(documentElement);

  doc.appendChild(kmlElement);

  const serializer = new XMLSerializer();
  const xmlString = serializer.serializeToString(doc);

  return xmlString;
};

function convertHexToABGR(hex: string) {
  if (hex) {
    hex = hex.split('').reverse().join('');
    hex = 'FF' + hex;
  }

  return hex;
}
